import _ from 'lodash'

class AccountService {
  constructor ($http, $log, config, $analytics, CurrentUserService, BillingService) {
    this.http = $http
    this.log = $log
    this.config = config
    this.endpoint = config.accountEndpoint
    this.analytics = $analytics
    this.BillingService = BillingService
    this.CurrentUserService = CurrentUserService
  }

  update(user, successCallback = function() {}, failureCallback = function() {}) {
    const uri = this.endpoint + '/user/' + user.userId
    const updates = this._userForUpdate(user)

    this.http.put(uri, updates).then(
      (response) => this._onUpdateFinished(response, successCallback, updates),
      (response) => this._onUpdateFinished(response, failureCallback, updates))
  }

  _onUpdateFinished(response, callback, updates = {}) {
    this.log.debug('Update finished')
    this.log.debug(response)

    this.analytics.eventTrack(
      'Account Details Updated',
      {
        updated: updates
      }
    )

    this.analytics.setUserProperties(updates)

    callback(response)
  }

  // Return a user that only includes the attributes we are updating
  _userForUpdate(user) {
    const currentUser = this.CurrentUserService.current
    return _.pick(user, (value, key) => {
      return !_.isEqual(value, currentUser[key])
    })
  }
}

AccountService.$inject = [
  '$http',
  '$log',
  'config',
  '$analytics',
  'CurrentUserService',
  'BillingService'
]

export default AccountService
